import {Spin } from 'antd';
import { StyledContainer } from './style';


export interface InputProps {
    message?: string,
    size?:"small" | "large" | "default" | undefined,
  }

  
const Spinner = ({message,size}:InputProps) => {
    return (
        <StyledContainer>
            <Spin size={size || "large"} tip={message || "در حال بارگذاری اطلاعات. لطفا صبور باشید"}/>
        </StyledContainer>
    )
}

export default Spinner 